<template>
	<div>
		<vx-card style="width: 250px" :title="title">
			<template slot="actions">
				<feather-icon icon="XIcon" @click.stop="toogleWindow" class="cursor-pointer"></feather-icon>
			</template>
			<div class="vx-row">
				<vue-perfect-scrollbar class="scroll-area" :settings="settings">
					<div
						class="vx-col sm:w-1/1 md:w-1/1 lg:w-full xl:w-full mb-2 pl-2 pr-2"
						v-for="legend in legends"
						:key="legend.id"
					>
						<p class="font-bold">{{ legend.resource.label | title }}</p>
						<hr
							:style="`width:100%;height:4px;border-width:0;color:gray;background-color:${legend.color}`"
						/>
						<div v-if="routeType === 'EXECUTED'">
							<p class="text-sm font-medium">
								<span>
									<span v-if="8 > 0">{{ $t("RoutesLegends.Distance") }}: </span>
								</span>
								<span>{{ accumulatedDistance(legend.route) | km_formatter }}</span>
							</p>
							<p class="text-sm font-medium">
								<span>
									<span>{{ $t("RoutesLegends.Time") }}: </span>
								</span>
								<span>{{ accumulatedTime(legend.route) }}</span>
							</p>
							<p class="text-sm font-medium">
								<span>
									<span>{{ $t("RoutesLegends.SpeedReached") }}: </span>
								</span>
								<span>{{ resolveSpeedValue(legend.route) }}</span>
							</p>
						</div>
						<div v-if="routeType === 'PROGRAMED'">
							<p class="text-sm font-medium">
								<span>
									<span v-if="8 > 0">{{ $t("RoutesLegends.TotalVisits") }}:</span>
								</span>
								<span>{{ legend.route.total_visit }}</span>
							</p>
						</div>
					</div>
				</vue-perfect-scrollbar>
			</div>
			<vs-divider class="my-6"></vs-divider>
			<div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">
				<!-- LEFT COL -->
				<div
					class="vx-col w-full md:w-full sm:w-1/1 lg:w-1/1 xl:w-1/1 flex flex-col justify-between"
					v-if="true"
				>
					<div>
						<span class="font-medium">{{ $t("Zonification.Zonification") }}</span>
						<!-- Previous Data Comparison -->
						<p class="mt-2 text-sm font-medium">
							<span>{{ $t("RoutesLegends.ViewZones") }}</span>
						</p>
					</div>
					<vs-button
						icon-pack="feather"
						icon="icon-octagon"
						icon-after
						class="shadow-md w-full lg:mt-0 mt-4"
						@click="drawZones"
						>{{ $t("Zonification.View") }}
						{{ $t("Zonification.Zonification") }}
					</vs-button>
				</div>

				<!-- RIGHT COL -->
				<div
					v-if="isDisabledButtonRemoveZones"
					class="
						vx-col
						w-full
						md:w-full
						sm:w-1/1
						lg:w-1/1
						xl:w-1/1
						flex flex-col flex-wrap
						lg:mb-0
						md:mb-base
						sm:mb-0
						mt-2
					"
				>
					<vs-button
						icon-pack="feather"
						icon="icon-trash"
						icon-after
						class="shadow-md w-full lg:mt-0 mt-4"
						color="danger"
						@click="clearPolygons"
						>{{ $t("Zonification.RemoveZones") }}
					</vs-button>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
	components: {
		VuePerfectScrollbar,
	},
	props: {
		getAssigedZoneResource: {
			type: Function,
		},
		clearPolygons: {
			type: Function,
		},
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			isGeo: false,
			isDisabledButtonRemoveZones: false,
		};
	},
	computed: {
		isToggleActive() {
			return this.$store.state.moduleMap.toggleRoutesLegends;
		},
		legends() {
			return this.$store.state.moduleMap.resourceRoutesLegends;
		},
		routeType() {
			return this.$store.state.moduleMap.routeType;
		},
		title() {
			return this.$store.state.moduleMap.routeType === "PROGRAMED"
				? this.$t("RoutesLegends.ProgramedRoutes")
				: this.$t("RoutesLegends.ExecutedRoutes");
		},
		accumulatedDistance() {
			return function (val) {
				if (typeof val === "object") {
					return val.hasOwnProperty("accumulated_distance") ? val.accumulated_distance : 0;
				} else {
					return 0;
				}
			};
		},
		accumulatedTime() {
			return function (val) {
				if (typeof val === "object") {
					return val.hasOwnProperty("accumulated_time") ? val.accumulated_time : 0;
				} else {
					return 0;
				}
			};
		},
		resolveSpeedValue() {
			return (route) => {
				if (route.max_speed) return route.max_speed + " Km/h";
				else return 0;
			};
		},
	},
	methods: {
		copyResults() {
			this.$refs.FormGeo.copyResults();
		},
		geoAgain() {
			this.$refs.FormGeo.geoCoder();
		},
		toogleWindow() {
			this.$store.commit("moduleMap/TOGGLE_ROUTES_LEGENDS", false);
		},
		showGeoAgain(val) {
			this.isGeo = val;
		},
		drawZones() {
			if (this.legends.length > 0) {
				this.isDisabledButtonRemoveZones = true;
				this.getAssigedZoneResource(this.legends);
			} else {
				this.isDisabledButtonRemoveZones = false;
			}
		},
	},
	destroyed() {
		this.toogleWindow();
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: 30vh;
}
</style>
